/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AorvImport } from './AorvImport';
import {
    AorvImportFromJSON,
    AorvImportFromJSONTyped,
    AorvImportToJSON,
} from './AorvImport';

/**
 * 
 * @export
 * @interface AorvImporteAusschnitt
 */
export interface AorvImporteAusschnitt {
    /**
     * Anzahl der zurückgegebenen AORV-Importe.
     * @type {number}
     * @memberof AorvImporteAusschnitt
     */
    anzahlAorvImporte: number;
    /**
     * Anzahl der für den Filter zur Verfügung stehenden AORV-Importe.
     * @type {number}
     * @memberof AorvImporteAusschnitt
     */
    anzahlAorvImporteGesamt: number;
    /**
     * 
     * @type {Array<AorvImport>}
     * @memberof AorvImporteAusschnitt
     */
    aorvImporte: Array<AorvImport>;
}

/**
 * Check if a given object implements the AorvImporteAusschnitt interface.
 */
export function instanceOfAorvImporteAusschnitt(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "anzahlAorvImporte" in value;
    isInstance = isInstance && "anzahlAorvImporteGesamt" in value;
    isInstance = isInstance && "aorvImporte" in value;

    return isInstance;
}

export function AorvImporteAusschnittFromJSON(json: any): AorvImporteAusschnitt {
    return AorvImporteAusschnittFromJSONTyped(json, false);
}

export function AorvImporteAusschnittFromJSONTyped(json: any, ignoreDiscriminator: boolean): AorvImporteAusschnitt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anzahlAorvImporte': json['anzahlAorvImporte'],
        'anzahlAorvImporteGesamt': json['anzahlAorvImporteGesamt'],
        'aorvImporte': ((json['aorvImporte'] as Array<any>).map(AorvImportFromJSON)),
    };
}

export function AorvImporteAusschnittToJSON(value?: AorvImporteAusschnitt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anzahlAorvImporte': value.anzahlAorvImporte,
        'anzahlAorvImporteGesamt': value.anzahlAorvImporteGesamt,
        'aorvImporte': ((value.aorvImporte as Array<any>).map(AorvImportToJSON)),
    };
}

